import IpubInput from './src/main'

/* istanbul ignore next */
IpubInput.install = function(Vue) {
  Vue.component(IpubInput.name, IpubInput)
}

export default IpubInput
